import React, { useState, useEffect } from 'react';
import NavMenu from 'components/NavMenu';
import { useStyles, styles } from './DiplomaScreenStyles';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import TextEvents from 'app/components/TextEvents';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import { useDispatch, useSelector } from 'react-redux';
//import * as SystemActions from '../../actions/SystemActions';
//import FilterScreen from './FilterComponent/FilterComponent';
//import TableScreen from './TableComponent/TableComponent';
import { Modal, Button, Spin, Table, Form, Select } from 'antd';
import { Grid } from '@material-ui/core';
import { employeeById } from 'app/reducers';
import TextInput from '../../../app/components/TextInput';
import { debounce } from 'debounce';
import ApiService from 'app/services/ApiService';
import * as Actions from './DiplomaScreenActions';

const DiplomaScreen = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { siteId } = useSelector(state => state.Auth)
    const employeeData = useSelector(employeeById);
    // const { diplomasSelected, setDiplomasSelected } = useState([]);
    // const { diplomasFilters, setDiplomasFilters } = useState([]);
    const [functional, setfunctional] = useState([]);
    const [diploma, setDiploma] = useState([]);
    const [archivo, setArchivo] = useState([]);

    useEffect(() => {
        dispatch(Actions.getFiltersDiploma({
            IdEmployee: employeeData.employeeId,
            IdCommunicationProgram: null
        }, saveFilters));
    }, [dispatch]);

    const saveFilters = (item = []) => {
        if (item == null || item == undefined) item = [];

        setfunctional(item)
    }

    async function setSelected(names) {
        setDiploma(names)
        let urls = [];

        for (var i = 0; i < names.length; i++) {
            var result = await Actions.getDiplomaFileAsync({
                IdCommunicationProgram: names[i],
                IdEmployee: employeeData.employeeId
            })
            const blob = new Blob([result], { type: 'application/pdf' });

            var indx = functional.findIndex(x => x.idComunicationProgram == names[i])

            if (indx > -1) {
                urls.push({
                    url: URL.createObjectURL(blob),
                    name: functional[indx].comunicationProgramName
                });
            }

        }

        setArchivo(urls);
    }

    const downloadFiles = () => {
        for (var i = 0; i < archivo.length; i++) {
            const link = document.createElement('a');
            link.href = archivo[i].url;
            link.download = `Diploma ${archivo[i].name}.pdf`;
            document.body.append(link);
            link.click();
            link.remove();
            window.addEventListener('focus', e => URL.revokeObjectURL(link.href), { once: true });
        }
    }

    const optionDiplomas = functional.map((item) =>
        (<Select.Option key={item.idComunicationProgram} value={item.idComunicationProgram}>{item.comunicationProgramName}</Select.Option>)
    );


    return (
        <div className={classes.root}>
            <NavMenu SelectedIndex={props.history.location.pathname} isCommunicationStatus={false} header='Mis Diplomas' />
            <CssBaseline />
            <div className={`${classes.content}`}>
                <div className={classes.appBarSpacer} />
                <div elevation={0} style={styles.titleBox}>
                    <Breadcrumbs aria-label="Breadcrumb">
                        <TextEvents
                            text="Mis Diplomas"
                            color="cotemar"
                            size='subtitle'
                            weight="bold"
                        />
                    </Breadcrumbs>
                    <Paper className={classes.rootPaper}>
                        <Grid container direction='row' spacing={2}>
                            <Grid item xs={6}>
                                <TextEvents
                                    text='Diplomas:'
                                    color='darker'
                                    size='label'
                                    weight='medium'
                                ></TextEvents>
                                <Select
                                    placeholder="[Selecionar Diplomas]"
                                    showSearch
                                    value={diploma}
                                    onChange={setSelected}
                                    style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                    optionFilterProp="Children"
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    mode="multiple"
                                >
                                    {optionDiplomas}
                                </Select>
                            </Grid>
                            <Grid item xs={6}>
                                <div className={classes.container} style={styles.baseVerticalMargin}>
                                    <Button
                                        className={classes.button}
                                        variant="contained"
                                        type="primary"
                                        disabled={archivo.length == 0}
                                        onClick={() => downloadFiles()}
                                    >
                                        Descargar
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                        <Grid container direction='row' spacing={2}>
                            {
                                archivo.map(i => {
                                    return <Grid item xs={12} style={{ height: '550px' }}>
                                        <TextEvents
                                            text={i.name}
                                            color='darker'
                                            size='label'
                                            weight='medium'
                                        ></TextEvents>
                                        <iframe src={i.url} width="100%" height="100%" toolbar={1} />
                                    </Grid>
                                })
                            }
                        </Grid>
                    </Paper>
                </div>
            </div>
        </div>
    )
}


export default DiplomaScreen;